import {
  CUSTOM_FIELDS,
  FLOAT_OPTIONS,
  FONTS,
  SHORT_WHITE_SPACE_OPTIONS,
  TEXT_ALIGN_OPTIONS,
  TEXT_DECORATION_OPTIONS,
  TEXT_TRANSFORM_OPTIONS,
  VERTICAL_ALIGN_OPTIONS,
  VISIBILITY_OPTIONS,
} from 'appConstants';
import { showErrorMessage } from 'helpers';
import axios from 'axios';

const colorProperty = {
  property: 'color',
  default: '',
};

const verticalAlignProperty = {
  name: 'Vertical align',
  property: 'vertical-align',
  type: 'radio',
  defaults: 'baseline',
  list: VERTICAL_ALIGN_OPTIONS,
};

const visibilityProperty = {
  name: 'Visibility',
  property: 'visibility',
  type: 'select',
  defaults: 'visible',
  options: VISIBILITY_OPTIONS,
};

const customLineHeightProperty = {
  name: 'Line height',
  property: 'line-height',
  type: 'radio',
  default: 'inherit',
  options: [
    {
      value: 'inherit',
      name: 'Inherit',
      className: 'icon icon-close',
    },
    {
      value: '100%',
      name: '100',
      className: 'icon icon-line-spacing-1x',
    },
    {
      value: '120%',
      name: '120',
      className: 'icon icon-line-spacing-2x',
    },
    {
      value: '150%',
      name: '150',
      className: 'icon icon-line-spacing-3x',
    },
    {
      value: '200%',
      name: '200',
      className: 'icon icon-line-spacing-4x',
    },
  ],
};

const textAlignProperty = {
  property: 'text-align',
  type: 'radio',
  defaults: 'justify',
  name: 'Text alignment',
  options: TEXT_ALIGN_OPTIONS,
};

const horizontalAlignByTextAlignProperty = {
  property: 'text-align',
  type: 'radio',
  defaults: 'left',
  name: 'Horizontal Alignment',
  options: TEXT_ALIGN_OPTIONS,
};

const fontFamilyProperty = {
  name: 'Font',
  property: 'font-family',
  defaults: FONTS[0].value,
  options: FONTS,
};

const widthFullProperty = {
  property: 'width',
  full: true,
};

const opacityProperty = {
  name: 'Opacity',
  type: 'slider',
  property: 'opacity',
  defaults: 1,
  step: 0.01,
  max: 1,
  min: 0,
};

const textTransformProperty = {
  name: 'Text transform',
  property: 'text-transform',
  type: 'radio',
  defaults: 'none',
  options: TEXT_TRANSFORM_OPTIONS,
};

const floatProperty = {
  name: 'Horizontal Alignment',
  property: 'float',
  type: 'radio',
  defaults: 'none',
  options: FLOAT_OPTIONS,
};

const whiteSpaceProperty = {
  name: 'Disable line wrap',
  property: 'white-space',
  type: 'radio',
  defaults: 'normal',
  options: SHORT_WHITE_SPACE_OPTIONS,
};

const textDecorationProperty = {
  property: 'text-decoration',
  type: 'radio',
  defaults: 'none',
  options: TEXT_DECORATION_OPTIONS,
};

const customMarginStyleTrait = {
  property: 'margin',
  name: 'Margin',
  type: 'margin-custom',
};

const customPaddingStyleTrait = {
  property: 'padding',
  name: 'Padding',
  type: 'padding-custom',
};

export const setPageWrapperSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: [
        'background-color',
        'font-family',
        'font-size',
        'font-weight',
        'letter-spacing',
        'color',
        'line-height',
        'text-align',
        'padding',
        'border',
      ],
      properties: [
        textAlignProperty,
        fontFamilyProperty,
        customPaddingStyleTrait,
      ],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const setWrapperSector = (editor) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['background-color'],
    },
  ]);
};

export const setVideoSector = (editor) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['width', 'padding', 'margin'],
      properties: [
        widthFullProperty,
        customPaddingStyleTrait,
        customMarginStyleTrait,
      ],
    },
  ]);
};

export const setImageTextSector = (editor) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['font-family', 'font-size', 'color', 'text-align'],
      properties: [textAlignProperty],
    },
  ]);
};

export const setColumnSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['background-color'],
      properties: [verticalAlignProperty],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const setImageBlockSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['background', 'opacity'],
      properties: [opacityProperty],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const setImageSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['float', 'opacity'],
      properties: [opacityProperty, floatProperty],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const setSectionSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['background-color'],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const setIconSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      properties: [floatProperty],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const setTextSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: [
        'font-family',
        'font-size',
        'font-weight',
        'letter-spacing',
        'color',
        'visibility',
        'text-align',
        'text-decoration',
        'text-transform',
      ],
      properties: [
        colorProperty,
        visibilityProperty,
        customLineHeightProperty,
        textAlignProperty,
        fontFamilyProperty,
        textDecorationProperty,
        textTransformProperty,
        whiteSpaceProperty,
      ],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const setButtonSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: [
        'background-color',
        'font-family',
        'font-size',
        'font-weight',
        'letter-spacing',
        'color',
        'visibility',
        'text-align',
        'text-decoration',
        'text-transform',
      ],
      properties: [
        customLineHeightProperty,
        visibilityProperty,
        fontFamilyProperty,
        {
          ...textAlignProperty,
          defaults: 'left',
        },
        textDecorationProperty,
        textTransformProperty,
      ],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const fetchCustomFields = async (apiUrl, trait) => {
  axios
    .get(apiUrl)
    .then((response) => {
      const options = response.data.map(({ id, name, price }) => ({
        id: `${id}|${price}`,
        name,
      }));

      // Update the trait's options
      trait.set('options', [
        { id: 'none', name: 'None' },
        ...CUSTOM_FIELDS,
        ...options,
      ]);
    })
    .catch(() => showErrorMessage('Error fetching the user products!'));
};

export const setDivWrapperSector = (editor, currentMode) => {
  editor.StyleManager.getSectors().reset([
    {
      name: 'Quick Styles & Settings',
      id: 'quickSector',
      open: true,
      buildProps: ['background-color', 'text-align'],
      properties: [horizontalAlignByTextAlignProperty],
    },
    ...(currentMode === 'advanced'
      ? editor.StyleManager.getConfig().sectors
      : []),
  ]);
};

export const removePropertyFromSector = (editor, sectorId, propertyName) => {
  const sm = editor.StyleManager;
  const sector = sm.getSector(sectorId);
  if (!sector) return;

  const properties = sector.get('properties');
  if (!properties) return;

  if (typeof properties.remove === 'function') {
    const prop = properties.find((p) => p.getName() === propertyName);
    if (prop) {
      properties.remove(prop);
    }
    return;
  }
};
